module.exports = __webpack_public_path__ + "static/backlite-media-result-2-2ad752a177810cf6b33d9d2fccc62ce3.png";